export default __webpack_public_path__ + "static/media/selectedhome.4c046c52.svg";